var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14526 16.3333C5.14526 16.687 5.28574 17.0261 5.53579 17.2761C5.78584 17.5262 6.12498 17.6667 6.4786 17.6667C6.83222 17.6667 7.17136 17.5262 7.42141 17.2761C7.67145 17.0261 7.81193 16.687 7.81193 16.3333C7.81193 15.9797 7.67145 15.6406 7.42141 15.3905C7.17136 15.1405 6.83222 15 6.4786 15C6.12498 15 5.78584 15.1405 5.53579 15.3905C5.28574 15.6406 5.14526 15.9797 5.14526 16.3333ZM14.4786 16.3333C14.4786 16.687 14.6191 17.0261 14.8691 17.2761C15.1192 17.5262 15.4583 17.6667 15.8119 17.6667C16.1656 17.6667 16.5047 17.5262 16.7547 17.2761C17.0048 17.0261 17.1453 16.687 17.1453 16.3333C17.1453 15.9797 17.0048 15.6406 16.7547 15.3905C16.5047 15.1405 16.1656 15 15.8119 15C15.4583 15 15.1192 15.1405 14.8691 15.3905C14.6191 15.6406 14.4786 15.9797 14.4786 16.3333ZM23.8119 16.3333C23.8119 16.687 23.9524 17.0261 24.2025 17.2761C24.4525 17.5262 24.7916 17.6667 25.1453 17.6667C25.4989 17.6667 25.838 17.5262 26.0881 17.2761C26.3381 17.0261 26.4786 16.687 26.4786 16.3333C26.4786 15.9797 26.3381 15.6406 26.0881 15.3905C25.838 15.1405 25.4989 15 25.1453 15C24.7916 15 24.4525 15.1405 24.2025 15.3905C23.9524 15.6406 23.8119 15.9797 23.8119 16.3333Z",
    stroke: "#A4A4A4",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreButton);
export default __webpack_public_path__ + "static/media/moreButton.3aaa894cd442f465d72f99f387cea506.svg";
export { ForwardRef as ReactComponent };